module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 33.d0e6c2a6.png";